import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-gray-50 border-t border-gray-100" data-id="element-1">
      <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold text-[#2D3748] mb-6 leading-tight" data-id="element-4">
            Sua academia não precisa de mais equipamentos. <br data-id="element-5" />
            <span className="text-[#FF6B35]" data-id="element-6">
              Precisa de mais alunos engajados.
            </span>
          </h2>

          <p className="text-xl text-gray-600 mb-10" data-id="element-7">
            Veja uma simulação real do sistema funcionando e entenda como
            podemos transformar sua retenção.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 items-center" data-id="element-8">
            <Button href="https://irongym.malbs.com.br/" size="lg" className="text-lg px-10 py-5 shadow-xl shadow-orange-200 hover:shadow-2xl hover:shadow-orange-300 transition-all" data-id="element-9">
              Visitar sistema
              <ArrowRight className="ml-2 h-6 w-6" data-id="element-10" />
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}